export default {
  currentLocale: (state) => state.locale
};
